module.exports = __webpack_public_path__ + "media/images/nowprinting-6267a3f2477609665351be7b5ecf118d.png";